<script lang="ts">
import { RouteNames } from "../../../utils/constants.ts";

export function getRouteXAccountsFiat() {
  return {
    name: RouteNames.X_ACCOUNTS_FIAT,
  };
}
</script>
<script setup lang="ts">
import BreadCrumbs from "../../../components/BreadCrumbs.vue";
import BasicCard from "../../../components/BasicCard.vue";
import MButton from "../../../components/buttons/MButton.vue";
import IconTopRight from "../../../components/icons/IconTopRight.vue";
import IconCirclePlus from "../../../components/icons/IconCirclePlus.vue";
import IconDollarExchange from "../../../components/icons/IconDollarExchange.vue";
import CashAccountBalanceCardWidget from "../../../widgets/cash/CashAccountBalanceCardWidget.vue";
import CashTransactionTab from "../../../widgets/cash/CashTransactionTab.vue";
import CashAccountDetailsTab from "../../../widgets/cash/CashAccountDetailsTab.vue";
import {getRouteXAccountsFiatTopUp} from "./fiat/TopUpBalance.vue";
import {getRouteXAccountsFiatSend} from "./fiat/Send.vue";
import TransactionsTableWidget from "../../../widgets/TransactionsTableWidget.vue";
import InputSearch from "../../../components/form/InputSearch.vue";
import { IconArrowLeft, IconArrowRight, IconMoney } from "@iconify-prerendered/vue-carbon";
import {IBalanceBlockItem} from "./Cards.vue";

const tabs = [
  {
    key: 'cash-accounts-transactions',
    title: 'Transactions',
    node: CashTransactionTab,
  },
  {
    key: 'cash-accounts-account-details',
    title: 'Account Details',
    node: CashAccountDetailsTab,
  },
];


const BalanceBlocks: IBalanceBlockItem[] = [
  {
    text: "Payments",
    amount: "€ 372.00",
    icon: IconMoney()
  },
  {
    text: "Deposits",
    amount: "€ 302.00",
    icon: IconArrowLeft()
  },
  {
    text: "Withdrawals",
    amount: "€ 72.00",
    icon: IconArrowRight()
  }
];
</script>

<template>
  <div class="flex flex-col gap-4 md:gap-6 px-4 md:px-0">
    <BreadCrumbs :title="$t('Cash Accounts')"/>

    <div class="flex flex-col lg:flex-row gap-4 md:gap-6">
      <div class="w-full lg:w-[384px]">
        <CashAccountBalanceCardWidget />
      </div>
      <div class="flex-grow">
        <BasicCard title="Payments and Transfers" class="justify-between">
          <div class="flex flex-col sm:flex-row gap-3 md:gap-4">
            <MButton
                kind="primary"
                size2="medium"
                :to="getRouteXAccountsFiatTopUp()"
                class="w-full sm:w-auto"
            >
              <IconCirclePlus />
              Top Up
            </MButton>
            <MButton
                kind="secondary"
                size2="medium"
                :to="getRouteXAccountsFiatSend()"
                class="w-full sm:w-auto"
            >
              Send Cash
              <IconTopRight/>
            </MButton>
            <MButton
                kind="default"
                size2="medium"
                :to="getRouteXAccountsFiatSend()"
                class="w-full sm:w-auto"
            >
              <IconDollarExchange />
              Exchange Cash
            </MButton>
          </div>
        </BasicCard>
      </div>
    </div>

    <BasicCard :tabs="tabs">

    </BasicCard>
  </div>

  <BreadCrumbs :title="$t('Cash accounts')" class="mb-4 md:mb-5 px-4 md:px-0"></BreadCrumbs>

  <div class="w-full h-full backdrop-blur-xl rounded-3xl p-4 md:p-6 flex flex-col gap-4 md:gap-6 border bg-gray-900/40 border-gray-800/30">

    <div class="w-full flex flex-col sm:flex-row justify-between items-start sm:items-center gap-3 sm:gap-0">
      <div class="flex items-center gap-3">
        <h2 class="font-[Sora] font-bold text-xl md:text-2xl leading-tight md:leading-[38px] text-white">Transactions</h2>
      </div>
      <InputSearch class="w-full sm:w-[253px]" placeholder="Search" />
    </div>

    <div class="bg-gray-800/30 rounded-lg p-4 md:p-6 flex flex-col md:flex-row md:items-center gap-4 md:gap-16">
      <div v-for="block in BalanceBlocks"
           class="flex gap-3 md:gap-4 justify-start md:justify-center items-center select-none font-['Sora'] font-bold">
        <div class="py-2.5 flex">
          <div class="h-full w-full rounded-full bg-blue-600/20">
            <component :is="block.icon" class="w-6 h-6 md:w-8 md:h-8 text-blue-400 m-3 md:m-4"></component>
          </div>
        </div>
        <div class="flex flex-col gap-1 md:gap-2">
          <span class="text-sm md:text-base leading-6 md:leading-[38px] text-gray-300">{{ block.text }}</span>
          <span class="text-lg md:text-2xl leading-7 md:leading-[38px] text-white">{{ block.amount }}</span>
        </div>
      </div>
    </div>

    <TransactionsTableWidget :show-filters="true" :show-pagination="true" />

  </div>
</template>

<style scoped lang="scss"></style>
